import React from 'react';
import {Route, Switch, withRouter} from 'react-router-dom'
import {connect} from 'react-redux';
import Header from 'components/Header/index';
import Sidebar from 'containers/SideNav/index';
import Footer from 'components/Footer';

import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION
} from 'constants/ActionTypes';
import {isIOS, isMobile} from 'react-device-detect';
import asyncComponent from '../util/asyncComponent';
import TopNav from 'components/TopNav';

class App extends React.Component {
  render() {
    const { match, drawerType, navigationStyle, horizontalNavPosition } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER) ? 'fixed-drawer' : drawerType.includes(COLLAPSED_DRAWER) ? 'collapsible-drawer' : 'mini-drawer';

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add('ios-mobile-view-height')
    } else if (document.body.classList.contains('ios-mobile-view-height')) {
      document.body.classList.remove('ios-mobile-view-height')
    }
    return (
      <div className={`app-container ${drawerStyle}`}>
        <Sidebar/>
        <div className="app-main-container">
          <div className="app-header">
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === ABOVE_THE_HEADER) &&
            <TopNav styleName="app-top-header"/>}
            <Header/>
            {(navigationStyle === HORIZONTAL_NAVIGATION && horizontalNavPosition === BELOW_THE_HEADER) &&
            <TopNav/>}

          </div>

          <main className="app-main-content-wrapper">
            <div className="app-main-content">
              <Switch>
                <Route path={`${match.url}/dashboard`} component={asyncComponent(() => import('./routes/DashboardPage'))}/> 
                <Route path={`${match.url}/payments`} component={asyncComponent(() => import('./routes/PaymentsPage'))}/> 
                <Route path={`${match.url}/new-interventions`} component={asyncComponent(() => import('./routes/NewInterventionsPage'))}/> 
                <Route path={`${match.url}/patients/:patientId`} component={asyncComponent(() => import('./routes/SinglePatientPage'))}/> 
                <Route path={`${match.url}/patients`} component={asyncComponent(() => import('./routes/PatientsPage'))}/> 
                <Route path={`${match.url}/appointments`} component={asyncComponent(() => import('./routes/AppointmentsPage'))}/> 
                <Route path={`${match.url}/expenses`} component={asyncComponent(() => import('./routes/ExpensesPage'))}/> 
                <Route path={`${match.url}/changelog`} component={asyncComponent(() => import('./routes/ChangelogPage'))}/> 
                <Route path={`${match.url}/profile`} component={asyncComponent(() => import('./routes/ProfilePage'))}/> 
                <Route path={`${match.url}/company-settings`} component={asyncComponent(() => import('./routes/CompanySettings'))}/> 
                <Route component={asyncComponent(() => import('components/Error404'))}/>
              </Switch>
            </div>
            <Footer/>
          </main>
        </div>
      </div>
    );
  }
}


const mapStateToProps = ({settings}) => {
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  
  return {
    drawerType, 
    navigationStyle, 
    horizontalNavPosition
  }
};

export default withRouter(connect(mapStateToProps)(App));


// WEBPACK FOOTER //
// ./app/index.js